import { createContext, useContext } from "react";
import { useDoctorPortalState } from "./useDoctorPortal";

const DoctorPortalContext = createContext(null);

export const DoctorPortalProvider = ({ children }) => {
  const value = useDoctorPortalState();
  return (
    <DoctorPortalContext.Provider value={value}>{children}</DoctorPortalContext.Provider>
  );
};

export const useDoctorPortalCtx = () => {
  const ctx = useContext(DoctorPortalContext);
  if (!ctx) {
    throw new Error("useDoctorPortalCtx must be used within DoctorPortalProvider");
  }
  return ctx;
};
